export const isDummyItem = (item: { name: string } | string): boolean => {
  const name = typeof item === 'string' ? item : item?.name;
  return ['combo sides', 'combo item', 'mix n match', "mix n' match"].includes(
    name?.toLowerCase().trim()
  );
};
